module.exports = __webpack_public_path__ + "static/media/nft-15.86fc553d.jpg";